import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';
import { MENU } from '@components/lwb/tabs/tabs.enum';
import { REDIRECT_REPORT_TO_DNA_REPORT_TABS } from './report.config';

/**
 * Redirect every navigation request to dna report tabs.
 * Guard to redirect /report/... To /tabs/dna-report/....
 *
 * @param {ActivatedRouteSnapshot} route Route.
 * @param {RouterStateSnapshot} state RouterStateSnapshot.
 * @returns {boolean}
 */
export const redirectReportToDnaReportTabs = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  const nav = inject(NavController);

  if (REDIRECT_REPORT_TO_DNA_REPORT_TABS) {
    const [firstPath, ...restPath] = state.url
      .split('/')
      .filter((item) => item !== '');
    if (firstPath === 'report') {
      if (Array.isArray(restPath)) {
        const [secondPath, ...restSecondPath] = restPath;
        if (secondPath === `SKIN`) {
          if (restSecondPath.some((o) => /take-picture|analysis/i.test(o))) {
            return true;
          }
        }

        const secondPathWithoutQuery = secondPath.split('?')[0];
        if (
          secondPathWithoutQuery.length > 0 &&
          secondPathWithoutQuery.toUpperCase() === 'ANCESTRY'
        ) {
          return true;
        }
      }

      nav.navigateForward(['tabs', MENU.DNA_REPORT, ...restPath].join('/'));
      return false;
    }
  }
  return true;
};
